import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Box } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LoginIcon from '@mui/icons-material/Login';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useDispatch, useSelector } from 'react-redux';
import { setLogin } from '../app/loginSlice';
import { clearActivities } from '../app/activitiesSlice';
import { clearAchievements } from '../app/achievementsSlice';
import { totalClearUsers } from '../app/usersSlice';
import { useOktaAuth } from '@okta/okta-react';
import EmsigniaDark from '@msi/cobalt-react/icons/emsignia-dark';
import EmsigniaLight from '@msi/cobalt-react/icons/emsignia-light';
import Avatar from '@msi/cobalt-react/icons/avatar';
import Button from '@msi/cobalt-react/button';
import { ThemeProvider } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { useTheme } from '@mui/material/styles';
import LightOff from '@msi/cobalt-react/icons/light-off';
import LightOn from '@msi/cobalt-react/icons/light-on';

const TopBar = ({ selectedMenu, isLoggedIn, toggleTheme }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const coreId = useSelector((state) => state.login.coreId)?.toUpperCase();
  const isDarkMode = useSelector((state) => state.theme.mode === 'dark');

  const { oktaAuth } = useOktaAuth();
  const callLogin = async () => oktaAuth.signInWithRedirect();
  const callLogout = async () => oktaAuth.signOut(
    {
      postLogoutRedirectUri: window.location.origin + '/',
    }
  );

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    window._loginEmail = '';
    window._loginRights = {};
    dispatch(setLogin({ email: '', rights: {}, roles: [], selectedRole: '', coreId: '' }));
    dispatch(clearActivities());
    dispatch(clearAchievements());
    dispatch(totalClearUsers());
    handleClose();
  };

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        {isDarkMode ? <EmsigniaLight /> : <EmsigniaDark />}
        <Typography variant="h6" sx={{paddingLeft: 1}}>AI GURU</Typography>
        <Typography variant="subtitle1" sx={{ flexGrow: 1, textAlign: 'center' }}></Typography>
        { false && (<>
          <IconButton size="large" edge="end" color="inherit" aria-label="settings">
            <SettingsIcon />
          </IconButton>
          <IconButton size="large" edge="end" color="inherit" aria-label="notifications">
            <NotificationsIcon />
          </IconButton>
        </>) }
        <Switch checked={isDarkMode} onChange={toggleTheme} color='info' icon={<LightOn color='#ffffff' />} checkedIcon={<LightOff />} />
        {isLoggedIn ? (
          <>


            <Button size="" buttonType='primary' onClick={handleMenu}>
              {coreId}
              &nbsp;
              <Avatar color="rgb(255, 255, 255)" />
            </Button>
            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={callLogout}>Logout</MenuItem>
            </Menu>
          </>
        ) : (
          <Button color="inherit" endIcon={<LoginIcon />} onClick={callLogin}>Login</Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;

